<!-- Zweck: Stellt die HTML-Struktur für shop dialogs alternativ artikel suche component im Frontend bereit. -->
@if (klassifizierung) {
  <div style="width: 99vw">
    <h1 mat-dialog-title>
      <table style="width: 100%">
        <tr>
          <td>
            <svg-icon>produktsuche_alternativ</svg-icon>
            Alternativen zu {{data.artikel.ArtikelName}} <article-dtp-icon [isDtp]="data.artikel.IstDtpArtikel"></article-dtp-icon> ({{data.artikel.PZN}})
            @if (data.wantedAmount > 1) {
              <div>
                Sie benötigen {{data.wantedAmount}} Stück.
              </div>
            }
          </td>
          <td>
            <mat-checkbox [(ngModel)]="onlyOnStock" (change)="search()">Nur Lagernde</mat-checkbox>
          </td>
          <td style="text-align: right; width: 1%">
            <mat-form-field appearance="outline">
              <mat-label>Gewählte Klassifizierung</mat-label>
              <mat-select [(value)]="klassifizierung" (selectionChange)="search()">
                @for (t of klassifizierungen|async; track t) {
                  <mat-option [value]="t.id">
                    {{t.label}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </td>
          <td style="text-align: right; width: 1%">
            <mat-button-toggle-group>
              <mat-button-toggle (click)="setTableLayout()"
                [disabled]="(isMobile|async) ? ((layoutMobile|async) == 'table') : ((layout|async) == 'table')"
                class="tut_shopview_view_tab"
                matTooltip="Tabellen-Ansicht">
                <svg-icon>tabellarische-ansicht</svg-icon>
              </mat-button-toggle>
              <mat-button-toggle (click)="setBoxLayout()"
                [disabled]="(isMobile|async) ? ((layoutMobile|async) == 'box') : ((layout|async) == 'box')"
                matTooltip="Box-Ansicht"
                class="tut_shopview_view_box">
                <svg-icon>box-ansicht</svg-icon>
              </mat-button-toggle>
            </mat-button-toggle-group>
          </td>
          <td style="text-align: right; width: 100px">
            <button mat-raised-button (click)="close()" matTooltip="Schließen">
              <svg-icon>error-clean</svg-icon>
            </button>
          </td>
        </tr>
      </table>
    </h1>
    <div mat-dialog-content style="min-height: 200px">
      <div>
        <div class="view_content {{fsize}}">
          @if ((total_count|async) == 0 && !(loading$|async)) {
            <div style="clear: both"></div>
          }
          @if ((total_count|async) == 0 && !(loading$|async)) {
            <div class="infobox">
              <h3>Keine Ergebnisse gefunden!</h3>
            </div>
          }
          @if ((loading$|async)) {
            <div style="clear: both"></div>
          }
          @if ((loading$|async)) {
            <div class="infobox">
              <div style="text-align: center">
                <div style="display: inline-block">
                  <mat-spinner></mat-spinner>
                </div>
              </div>
              <h3>Suche läuft!</h3>
            </div>
          }
          @if (!(loading$|async)) {
            <div>
              @if ((total_count|async) > 0 && (isMobile|async) ? ((layoutMobile|async) == 'table') : ((layout|async) == 'table')) {
                <shop-view-result-table
                  [entries]="entries"
                  [viewcomp]="this"
                  [view]="data.view"
                  [infoText]="(loading$|async) ? 'Lade...' : ((total_count|async)+' Artikel')"
                  [visible_artikel_aktionen]="visible_artikel_aktionen"
                  [showView]="true"
                  [fieldsSaveable]="false"
                ></shop-view-result-table>
              }
              @if ((total_count|async) > 0 && (isMobile|async) ? ((layoutMobile|async) == 'box') : ((layout|async) == 'box')) {
                <shop-view-result-box
                  [entries]="entries"
                  [viewcomp]="this"
                  [view]="data.view"
                  [infoText]="(loading$|async) ? 'Lade...' : ((total_count|async)+' Artikel')"
                  [visible_artikel_aktionen]="visible_artikel_aktionen"
                  [showView]="true"
                  [fieldsSaveable]="false"
                ></shop-view-result-box>
              }
            </div>
          }
        </div>
      </div>
    </div>
    <div mat-dialog-actions>
      <mat-paginator [pageIndex]="page-1" [pageSize]="limit" [length]="total_count|async" [pageSizeOptions]="pageSizes"
      (page)="doPage($event)"></mat-paginator>
    </div>
  </div>
}
